import { Controller } from "@hotwired/stimulus";
import debounce from "../lib/debounce";

const VARIABLE_PATTERN = /\{\{\s*([\w.]+)\s*(?:\|[^}]*)?\}\}/g;

function extractVariables(text) {
  const variables = new Set();

  for (const [, name] of text.matchAll(VARIABLE_PATTERN)) {
    variables.add(name.toLowerCase());
  }

  return variables;
}

function missingVariablesByLocale(translations) {
  const allVariables = new Set();
  translations.forEach((translation) => translation.variables.forEach((name) => allVariables.add(name)));

  return new Map(
    translations.map((translation) => [
      translation.locale,
      translation.hasText ? [...allVariables].filter((name) => !translation.variables.has(name)).sort() : [],
    ]),
  );
}

export default class extends Controller {
  static targets = ["body", "warning"];

  static values = {
    warningTemplate: String,
  };

  initialize() {
    this.checkParity = debounce(this.render.bind(this), 200);
  }

  connect() {
    this.render();
  }

  disconnect() {
    this.checkParity.cancel();
  }

  render() {
    const translations = this.bodyTargets.map((body) => ({
      locale: body.dataset.locale,
      hasText: body.value.trim().length > 0,
      variables: extractVariables(body.value),
    }));

    const missing = missingVariablesByLocale(translations);

    this.warningTargets.forEach((warning) => {
      this.renderWarning(warning, missing.get(warning.dataset.locale) ?? []);
    });
  }

  renderWarning(warning, missing) {
    if (missing.length === 0) {
      warning.hidden = true;
      warning.textContent = "";

      return;
    }

    warning.hidden = false;
    warning.textContent = this.warningTemplateValue.replace("%{variables}", missing.join(", "));
  }
}
